export class EmployeeInvitation {
  id: string;
  status: string;
}
export enum EmployeeInvitationRedirectStatus {
  WAITING_FOR_TWO_FACTOR_CODE = 'WAITING_FOR_TWO_FACTOR_CODE',
  SUCCESS = 'SUCCESS',
  INVALIDATED = 'INVALIDATED',
  USED = 'USED',
  EXPIRED = 'EXPIRED',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED'
}
